// Парсер URL → тип страницы

/**
 * Парсит URL путь и определяет тип страницы
 * @param {string} path - путь URL
 * @returns {object} - объект с типом страницы и параметрами
 */
export function parseRoute(path) {
  // Нормализуем путь: убираем начальный и конечный слеш
  const normalizedPath = path.replace(/^\/+|\/+$/g, '');

  // Специальные маршруты
  if (normalizedPath === '' || normalizedPath === '/') {
    return { type: 'home' };
  }

  if (normalizedPath === 'telegram') {
    return { type: 'telegram' };
  }

  if (normalizedPath === 'orders') {
    return { type: 'orders' };
  }

  if (normalizedPath === 'zvonki') {
    return { type: 'zvonki' };
  }

  if (normalizedPath === 'blog') {
    return { type: 'blog' };
  }

  if (normalizedPath.startsWith('blog/')) {
    const slug = normalizedPath.replace('blog/', '').replace(/\/+$/, '');
    if (slug) {
      return { type: 'blogArticle', slug };
    }
    return { type: 'blog' };
  }

  return { type: 'notFound' };
}
